import React from "react";

export const PartnerAuthContext = React.createContext({
  user: null,
  token: null,
  validate: () => {},
});
